import React from 'react';
import Modal from 'react-modal';
import classNames from 'classnames';

const CustomModal = (props) => {
  const {
    title,
    isOpen,
    children,
    showClose,
    onClose,
    className
  } = props;

  const modalClasses = classNames('lc-modal', className);

  return <Modal
    isOpen={isOpen}
    className={modalClasses}
    overlayClassName='lc-modal-overlay'>
    { title && <h2 className='lc-modal-title'>{title}</h2> }
    { showClose && <div className='lc-modal-close'>
      <button className='lc-modal-btn' onClick={onClose}>&times;</button>
    </div>
    }
    <div className='lc-modal-body'>
      { children }
    </div>
  </Modal>;
};

CustomModal.defaultProps = {
  isOpen: false,
  showClose: true,
  className: ''
};

export default CustomModal;

